export { isVirtualElement } from '@fluentui/dom-utilities';
